export enum TrackingEvent {
    //
    // Page Views & Performance
    //
    PAGE_VIEWED = 'page_viewed',
    PAGE_LOAD_PERFORMANCE = 'page_load_performance',
    PAGE_LOAD_FAILED = 'page_load_failed',

    //
    // List Views
    //
    OBSERVATION_LIST_VIEWED = 'observation_list_viewed',
    TICKET_LIST_VIEWED = 'ticket_list_viewed',
    INVOICE_LIST_VIEWED = 'invoice_list_viewed',
    COMMUNICATIONS_LIST_VIEWED = 'communications_list_viewed',
    REPORTED_PLATES_LIST_VIEWED = 'reported_plates_list_viewed',
    PRESET_VIEWED = 'preset_viewed',
    LIST_INTERACTION = 'list_interaction',

    //
    // Navigation & Errors
    //
    PAGE_NAVIGATED = 'page_navigated',
    NAVIGATION_ERROR = 'navigation_error',

    //
    // Individual Actions
    //
    OBSERVATION_VIEWED = 'observation_viewed',
    TICKET_VIEWED = 'ticket_viewed',
    NOTE_ADDED = 'note_added',
    NOTE_EDITED = 'note_edited',
    NOTE_REMOVED = 'note_removed',
    OFFENDER_ADDED = 'offender_added',
    OFFENDER_EDITED = 'offender_edited',
    PERSON_ADDED = 'person_added',
    OWNER_ADDED = 'owner_added',
    OWNER_EDITED = 'owner_edited',
    SYNC_OFFENDER = 'sync_offender',
    STATUS_CHANGE = 'status_change',
    OBJECTION_ADDED = 'objection_added',
    OBJECTION_HANDLED = 'objection_handled',
    DECISION_ADDED = 'decision_added',
    DOCUMENT_CREATED = 'document_created',
    DOCUMENT_SENT = 'document_sent',
    DOCUMENT_MARKED_AS_SENT = 'document_marked_as_sent',
    MEDIATION_PROPOSED = 'mediation_proposed',
    OFFENSE_EDITED = 'offense_edited',
    VEHICLE_EDITED = 'vehicle_edited',
    IMAGE_ADDED = 'image_added',
    IMAGE_REMOVED = 'image_removed',
    PAYMENT_ADDED = 'payment_added',
    CCM_ADDED = 'ccm_added',
    CCM_EDITED = 'ccm_edited',
    CCM_CANCELLED = 'ccm_cancelled',
    CCM_FINALISED = 'ccm_finalised',
    DOCUMENT_UPLOADED = 'document_uploaded',
    OBJECTION_EDITED = 'objection_edited',
    OBSERVATION_MARKED_AS_RECEIVED = 'observation_marked_as_received',
    SANCTIONING_OFFICER_EDITED = 'sanctioning_officer_edited',
    CASE_MANAGER_ASSIGNED = 'case_manager_assigned',
    PERSON_EDITED = 'person_edited',
    PREDICTED_AMOUNT_ADDED = 'predicted_amount_added',
    OBSERVATION_EXPORTED = 'observation_exported',
    MEDIA_ANONYMISED = 'media_anonymised',
    LICENSE_PLATE_ADDED_TO_REVIEW_LIST = 'license_plate_added_to_review_list',
    DRIVER_CHANGE_HANDLED = 'driver_change_handled',
    DRIVER_IDENTIFICATION_EDIT_STARTED = 'driver_identification_edit_started',
    OBSERVATION_CREATED = 'observation_created',
    PASSWORD_CHANGED = 'password_changed',
    PRESET_SAVED = 'preset_saved',
    PRESET_UPDATED = 'preset_updated',

    //
    // Action Failures
    //
    ACTION_FAILED = 'action_failed',

    //
    // Batch Actions
    //
    BATCH_ACTION_PERFORMED = 'batch_action_performed',
    BATCH_ACTION_FAILED = 'batch_action_failed',
    BATCH_ACTION_PERFORMANCE = 'batch_action_performance',

    //
    // Wizard Flows
    //
    WIZARD_STEP_COMPLETED = 'wizard_step_completed',
    WIZARD_COMPLETED = 'wizard_completed',
    WIZARD_ABANDONED = 'wizard_abandoned',
    WIZARD_ERROR = 'wizard_error',

    //
    // Insights
    //
    INSIGHTS_DASHBOARD_TAB_SWITCHED = 'insights_dashboard_tab_switched',
    INSIGHTS_DASHBOARD_ACTION = 'insights_dashboard_action',
    INSIGHTS_CHAT_OPENED = 'insights_chat_opened',
    INSIGHTS_AUTHORIZATION_EXPIRED = 'insights_authorization_expired',

    //
    // Global Chrome
    //
    MENU_NAVIGATED = 'menu_navigated',
    GLOBAL_SEARCH_PERFORMED = 'global_search_performed',
    LOGOUT_PERFORMED = 'logout_performed',
    HELP_OPENED = 'help_opened',
    WHATS_NEW_OPENED = 'whats_new_opened',
}
